import { render, staticRenderFns } from "./myGsList.vue?vue&type=template&id=a05f70b8&scoped=true&"
import script from "./myGsList.vue?vue&type=script&lang=js&"
export * from "./myGsList.vue?vue&type=script&lang=js&"
import style0 from "./myGsList.vue?vue&type=style&index=0&id=a05f70b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05f70b8",
  null
  
)

export default component.exports